import API from 'app/utils/apiClient';

const migrateData = (key, data) => {
  return API.post('/supports/web-data-migrate/', { key, data });
};

export default { migrateData };



// WEBPACK FOOTER //
// ./src/app/apis/support.js